<template>
    <el-container v-wechat-title="title" :style="{ height: screenHeight2 + `px` }" v-if="this.surgeryId > 0">
        <el-aside width="260px" v-show="collapse == 0">
            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                <el-menu style="margin-top: 40px" class="document-list">
                    <template v-for="(item, index) in documentList">
                        <el-tooltip :key="index" class="item" effect="light" :content="item.docname" placement="right">
                            <el-menu-item :key="item.index" :index="item.index" @click="loadDocumentPage(item)" :style="{ color:(activeDoc && item.id == activeDoc.id)?`var(--primary-color, #009688) !important`:`black !important`}">
                                <div slot="title" class="align-left">
                                    <span class="el-icon-document"></span>
                                    <span class="ellipsis" style="width: 160px">{{ item.docname }}</span>
                                </div>
                            </el-menu-item>
                        </el-tooltip>
                    </template>
                </el-menu>
            </el-scrollbar>
        </el-aside>
        <el-main class="width-p100" style="padding: 0; overflow: hidden">
            <div class="width-p100" style="position: absolute; background: whitesmoke; margin-left: -260px; z-index: 2; display: flex; justify-content: flex-start; align-items: center; height: 40px">
                <span style="width: 260px; text-align: left"> 文书明细</span>
                <i style="cursor: pointer" :class="collapse == 1 ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="triggerCollapse()"></i>
            </div>
            <div v-if="activeDoc" :style="{ 'margin-top': '42px', height: screenHeight2 + `px` }">
                <el-scrollbar v-loading="loading">
                    <div :style="{ padding: '10px', height: screenHeight2 - 50 + `px` }">
                        <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
                    </div>
                </el-scrollbar>
            </div>
            <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
        </el-main>
    </el-container>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
// import pdf from '@/common/vue-pdf-4.1.0'
import { mapGetters } from 'vuex'
import pdf from "vue-pdf"
export default {
    name: `HistoryDocument`,
    components: {
        pdf
    },
    props: {},
    data() {
        return {
            collapse: 0,
            title: `历史文书`,
            activeDoc: undefined,
            numPages: 0,
            loading: false,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            documentList: []
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`, `currentSurgery`, `active_ward`, `permissions`]),
        screenHeight2() {
            let r = typeof winformMsg
            if (r != `undefined` && this.$route.path == `/document2`) {
                // 麻醉单里面的文书tab页签
                return this.screenHeight - 126
            } else {
                return this.screenHeight - 106
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        triggerCollapse() {
            if (this.collapse == 0) {
                this.collapse = 1
            } else {
                this.collapse = 0
            }
            this.$emit(`triggerCollapse`, this.collapse)
        },
        init() {
            if (this.surgeryId) {
                return new Promise((resolve, reject) => {
                    let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetHistoryDocuments?surgeryId=${this.surgeryId}`)
                    req.then(data => {
                        this.documentList = data
                    }).catch(e => {
                        console.log(e)
                    })
                })
            }
        },
        loadDocumentPage(item) {
            let that = this
            if (item && item.id && that.surgeryId) {
                let req = that.myaxios.post(`/api/AcisSystem/DocumentConfig/GetDocumentPdf?surgeryId=${that.surgeryId}&docArchiveId=${item.id}`)
                req.then(data => {
                    if (data) {
                        that.activeDoc = item
                        that.loading = true
                        that.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                        that.src.promise.then(content => {
                            that.numPages = content.numPages
                            that.loading = false
                        }).catch(err => { console.error(`pdf 加载失败`, err) })
                    }
                    that.base64 = data
                }).catch(e => console.log(e))
            }
        }

    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.activeDoc = undefined
            this.init()
        }
    }
}
</script>
<style scoped lang="less" >
ul,
li {
    list-style: none;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
</style>
<style lang="less">
.document-list {
    .el-submenu__icon-arrow {
        left: -220px;
    }
    .btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -12px;
        font-size: 16px;
        z-index: 2;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Document/HistoryDocument.vue